// Win Your Wedding — shared helpers for the staff page and the public pages.

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || '';
const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY || '';

export const WYW_GREEN = '#213D30';
export const WYW_GOLD = '#C4A053';
const TZ = 'Europe/Dublin';

// Couples and hosts don't log in: every public action goes through the wyw edge function.
export async function callWyw(action, payload = {}) {
  const res = await fetch(`${supabaseUrl}/functions/v1/wyw`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${supabaseKey}`, apikey: supabaseKey },
    body: JSON.stringify({ action, ...payload }),
  });
  let data = {};
  try { data = await res.json(); } catch (_) { /* empty */ }
  if (!res.ok) {
    const err = new Error(data.error || `Request failed (${res.status})`);
    err.code = data.error;
    throw err;
  }
  return data;
}

function parts(iso) {
  const out = {};
  new Intl.DateTimeFormat('en-GB', {
    timeZone: TZ, weekday: 'short', day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit', hour12: false,
  }).formatToParts(new Date(iso)).forEach((p) => { out[p.type] = p.value; });
  return out;
}

// "2:45pm"
export function fmtTime(iso) {
  if (!iso) return '';
  const p = parts(iso);
  const h = Number(p.hour) % 24;
  return `${h % 12 || 12}:${p.minute}${h < 12 ? 'am' : 'pm'}`;
}

// "Sun 31 Jan"
export function fmtDay(iso) {
  if (!iso) return '';
  const p = parts(iso);
  return `${p.weekday} ${p.day} ${p.month}`;
}

export function fmtSlot(iso) {
  return iso ? `${fmtDay(iso)}, ${fmtTime(iso)}` : '';
}

// "Today", "Yesterday", "3 days ago", or a date
export function fmtAgo(iso) {
  if (!iso) return '';
  const day = (d) => new Intl.DateTimeFormat('en-CA', { timeZone: TZ }).format(d);
  const a = new Date(`${day(new Date())}T00:00:00Z`);
  const b = new Date(`${day(new Date(iso))}T00:00:00Z`);
  const n = Math.round((a - b) / 86400000);
  if (n <= 0) return 'Today';
  if (n === 1) return 'Yesterday';
  if (n < 14) return `${n} days ago`;
  return fmtDay(iso);
}

export function daysAgo(iso) {
  return iso ? (Date.now() - new Date(iso).getTime()) / 86400000 : Infinity;
}

// not booked → booked → fully entered
export function coupleStatus(c) {
  if (c.entered_at) return 'entered';
  if (c.slot_at) return 'booked';
  return 'none';
}

export const STATUS_LABEL = { none: 'Not booked', booked: 'Booked', entered: 'Fully entered ✓' };

export const ERROR_TEXT = {
  slot_full: 'That time has just filled up. Please pick another.',
  host_busy: "That host is already booked at this couple's time. Pick a new time first.",
  bad_slot: "That time isn't available.",
  already_entered: "You're already fully entered. See you on the Final Night!",
  not_found: "We couldn't find this link. Please reply to your email and we'll sort it.",
  pool_not_locked: 'Close check-in first.',
  pool_empty: 'Nobody left in the draw.',
  all_drawn: 'All 10 finalists are drawn.',
};

export function errorText(e) {
  const code = e?.code || e?.message || '';
  const key = Object.keys(ERROR_TEXT).find((k) => String(code).includes(k));
  return key ? ERROR_TEXT[key] : 'Something went wrong. Please try again.';
}

export const appBaseUrl = () => window.location.origin;
export const bookLink = (token) => `${appBaseUrl()}/?wyw_book=${token}`;
export const tonightLink = (token) => `${appBaseUrl()}/?wyw_tonight=${token}`;
export const enterLink = () => `${appBaseUrl()}/?wyw_enter=1`;
